// Re-exports from lyrics.connector.ts for backward compatibility.
// All lyrics and lyrics-reports services are now unified in lyrics.connector.ts.
export type { AnonymousLyricsReportRequest } from "./lyrics.connector";
export { adminLyricsReportsService, anonymousLyricsReportsService } from "./lyrics.connector";
